module.exports = __webpack_public_path__ + "img/step_4.c4af0590.webp";